import React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "newui/store";
import type { Company } from "../../types";
import SkeletonBase from "newui/components/Skeleton";
import CompanyLocationForm from "./CompanyLocationForm";

const CompanyLocationFormContainer: React.FC = () => {
	const company = useSelector(
		(state: RootState) => state.search.activeCompany
	) as Company | undefined;

	if (!company) {
		return (
			<div className="px-4">
				{Array.from({ length: 2 }).map((_, i) => (
					<div
						key={i}
						className="my-4 flex w-full items-center justify-between gap-8"
					>
						<div className="w-2/4">
							<div className="my-2">
								<SkeletonBase height="18px" />
							</div>
							<SkeletonBase width="100%" height="56px" />
						</div>
						<div className="w-2/4">
							<div className="my-2">
								<SkeletonBase height="18px" />
							</div>
							<SkeletonBase width="100%" height="56px" />
						</div>
					</div>
				))}
			</div>
		);
	}

	return <CompanyLocationForm company={company} />;
};

export default CompanyLocationFormContainer;
